export const HEAP_SEGMENT_BROWSER_LIBRARY_NAME = 'browser-destination'
